import React from 'react';
import { Col, Row, Modal } from 'react-bootstrap';
import PersonalRecordTable from './PersonalRecordTable';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import { icon } from 'leaflet';
import { useState } from 'react';
import PersonalRecordForm from './PersonalRecordForm';

const PersonalRecords = () => {
    const [showModal, setShowModal] = useState(false);
    const [refreshList, setRefreshList] = useState(false);
  const buttonsConf = [
    {
      name: 'Add PR',
      icon: 'plus',
      type: 'button',
      variant: 'info',
      onClick: () => {
        setShowModal(true);
      }
    }
  ];

  const headerGenerated = useHeaderGenerator(
    'Personal Records',
    ' ',
    buttonsConf
  );
  return (
    <>
      {headerGenerated}
      <PersonalRecordTable refreshList={refreshList} setRefreshList={setRefreshList} />
      <Modal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Personal Record</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <PersonalRecordForm setShowFormModal={setShowModal} refreshRecords={() => setRefreshList(true)} />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PersonalRecords;
